module.exports = __webpack_public_path__ + "media/common/fonts/streamline-small/streamline-small-36b421f552faa43ca649c9af4ee742d8.svg";